


























import { Component, PropSync, Vue } from 'vue-property-decorator';
import { currencyFormat } from '@/vue-app/utils/currency';

import GoalEarningsViewModel
  from '@/vue-app/view-models/components/goals-dashboard/details-goals/goal-earnings-view-model';

@Component({
  name: 'GoalEarnings',
  components: {
    CustomTooltip: () => import('@/vue-app/components/custom/CustomTooltip.vue'),
  },
  filters: { currencyFormat },
})
export default class GoalEarnings extends Vue {
  @PropSync('investorGoalId', { type: String, required: true })
  investor_goal_id!: string;

  @PropSync('activeGoalAmount', { type: Number, required: true })
  active_goal_amount!: number;

  @PropSync('totalEarnings', { type: Number, required: true })
  total_earnings!: number;

  @PropSync('earningsPercentage', { type: Number, required: true })
  earnings_percentage!: number;

  @PropSync('strategyOption', { type: String, required: true })
  strategy_option!: string;

  view_model = Vue.observable(
    new GoalEarningsViewModel(this),
  );

  created() {
    this.view_model.initialize(
      this.strategy_option, this.investor_goal_id,
    );
  }
}
